<script setup>
import { computed } from 'vue'

const props = defineProps({
  progress: { type: Number, required: true },
  completed: { type: Boolean, required: false }
})

const dash = computed(() => {
  const pct = Math.min(Math.max(props.progress, 0), 1) * 100
  return `${pct}, 100`
})
</script>

<template>
  <div class="circle-wrapper">
    <svg viewBox="0 0 36 36" class="circular-chart">
      <path
        class="circle-bg"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />

      <path
        v-if="!completed"
        class="circle"
        :stroke-dasharray="dash"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />

      <!-- Tick -->
      <g v-if="completed" class="tick">
        <polyline points="12,20 16,24 24,14" />
      </g>
    </svg>
  </div>
</template>